import { useTranslation } from 'react-i18next';

import Product from 'components/product/Product';
import {getData} from "components/product/util";

import img1 from 'assets/images/solutions/modules/ji/module_02.jpg'

export default function ProductJi(){
  const {t}=useTranslation();
  const products = getData(t, "modules", "ji");
 
  // 그림 이름은 대중이 없어서 따로 넣어야 함.
  products[0].images = [img1];

  return (
    <Product products={products}/>
  );
}